import { getColor, formatDateString } from '@/plugins/utils/utils';
import { L } from '@/plugins/utils/i18n';

export function setArt2ChartOption (artifact_chart, artifact_data) {
  if (!artifact_chart || !artifact_data) { // 尚未初始化
    return;
  }

  const data = [];
  const dataLeave = [];

  const wakes = []; // 记录所有wake段，用于过滤wake期间的体动减弱显示
  if (artifact_data.stages) {
    for (let i = 0; i < artifact_data.stages.length; i++) {
      if (artifact_data.stages[i].value === 1) {
        wakes.push([artifact_data.stages[i].start, artifact_data.stages[i].end]);
      }
    }
  }

  if (artifact_data.segments && artifact_data.segments.length > 0) {
    const offset = artifact_data.start;
    const end = artifact_data.end;
    let lastend = 0;
    // console.log(artifact_data.segments);
    for (let i = 0; i < artifact_data.segments.length; i++) {
      // 检查 segments[i] 是否有必要的属性
      if (!artifact_data.segments[i] || artifact_data.segments[i].s === undefined || artifact_data.segments[i].e === undefined) {
        console.warn('体动图 segments 数据格式错误，跳过该元素:', artifact_data.segments[i]);
        continue;
      }
      let inWake = false;
      for (let j = 0; j < wakes.length; j++) { // 检查是否与wake段重合
        if ((artifact_data.segments[i].s >= wakes[j][0] && artifact_data.segments[i].s <= wakes[j][1]) ||
                    (artifact_data.segments[i].e >= wakes[j][0] && artifact_data.segments[i].e <= wakes[j][1])) {
          inWake = true;
          break;
        }
      }
      data.push([offset + artifact_data.segments[i].s, offset + artifact_data.segments[i].e, artifact_data.segments[i].v || 0, inWake ? 0 : 1]);
      lastend = offset + artifact_data.segments[i].e;
    }
    // 只有在有数据的情况下才检查是否需要添加结尾对齐数据
    if (data.length > 0 && offset + artifact_data.segments[artifact_data.segments.length - 1].e < end) {
      data.push([lastend, end, 0]);
    } else if (data.length === 0) {
      // 如果没有数据，至少添加开始和结束的对齐数据
      data.push([offset, offset + 60, 0]);
      data.push([end - 60, end, 0]);
    }
  } else {
    // 如果没有 segments 数据，至少添加开始和结束的对齐数据
    const offset = artifact_data.start || 0;
    const end = artifact_data.end || 0;
    if (end > offset) {
      data.push([offset, offset + 60, 0]);
      data.push([end - 60, end, 0]);
    }
  }
  let hasLeaveData = false;
  if (artifact_data.leavebed) {
    const offset = artifact_data.start;
    for (let i = 0; i < artifact_data.leavebed.length; i++) {
      if (offset + artifact_data.leavebed[i].e <= artifact_data.end) {
        hasLeaveData = true;
        dataLeave.push([offset + artifact_data.leavebed[i].s, offset + artifact_data.leavebed[i].e, 4]);
      }
    }
  }

  const legendColors = ['#f2bd7d', '#f0a055', '#ee7624', '#8E377A'];
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: L.movement,
      padding: [4, 0, 0, 36],
      textStyle: {
        fontWeight: 'normal',
        fontSize: 12
      }
    },
    grid: {
      left: '8%',
      right: '8%',
      top: hasLeaveData ? 20 : 14,
      bottom: hasLeaveData ? 14 : 4,
      containLabel: true
    },
    xAxis: {
      min: 'dataMin',
      max: 'dataMax',
      minInterval: 120 * 60,
      maxInterval: 120 * 60,
      offset: -5,
      axisLabel: {
        showMinLabel: true,
        showMaxLabel: true,
        formatter: function (val) {
          return formatDateString(val * 1000, 'HHmm');
        }
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      min: function (value) { return -value.max*2/3 },
      max: function (value) { return value.max*2/3 },
      show: false,
      axisLabel: { show: false }
    },
    tooltip: {
      confine: true,
      shadowBlur: 4,
      backgroundColor: getColor('background'),
      borderColor: 'transparent',
      textStyle: {
        fontSize: 12,
        lineHeight: 9,
        textShadowBlur: 2,
        textShadowColor: 'transparent',
        color: getColor('text')
      },
      formatter: function (params) {
        return formatDateString(params.value[0] * 1000, 'HHmm') +
                    // + ' - ' + formatDateString(params.value[1]*1000, "HHmm")
                    ' ' + params.value[2] + L.times;
      }
    },
    legend: hasLeaveData ? {
      data: [{
        name: L.movement,
        itemStyle: { color: legendColors[2] }
      }, {
        name: L.leave_bed,
        // icon: 'roundRect',
        itemStyle: { color: legendColors[3] }
      }],
      orient: 'horizontal',
      bottom: 0,
      selectedMode: false,
      icon: 'circle',
      itemHeight: 12,
      itemWidth: 14
    } : { show: false },
    series: [
      {
        type: 'custom',
        name: L.movement,
        renderItem: function (params, api) {
          const start = api.coord([api.value(0), 0]);
          // var end = api.coord([api.value(0) + (api.value(1)-api.value(0)) * api.value(2)/ (1+api.value(2)), api.value(2)]);
          const end = api.coord([api.value(1), api.value(2)]);
          const height = api.size([0, 1])[1] * api.value(2);
          const inSleep = api.value(3);
          return {
            type: 'rect',
            shape: {
              x: start[0],
              y: end[1] + height / 2,
              width: end[0] - start[0],
              height,
              r: 2
            },
            style: {
              ...api.style(),
              fill: inSleep ? legendColors[2] : legendColors[2],
              opacity: inSleep ? 1 : 0.1
            },
            emphasis: {
              style: {
                stroke: legendColors[2],
                opacity: 1,
                lineWidth: 2
              }
            }
          }
        },
        encode: {
          x: [0, 1],
          y: 2
        },
        data
      }, {
        type: 'custom',
        name: L.leave_bed,
        renderItem: function (params, api) {
          const start = api.coord([api.value(0), 0]);
          const end = api.coord([api.value(1), 0]);
          const height = api.size([0, 1])[1] * 3;
          const width = end[0] - start[0];

          const mWidth = 7;
          const mHeight = 6;
          return {
            type: 'group',
            children: [{
              type: 'rect',
              shape: {
                ...api.style(),
                x: start[0],
                y: start[1] - height / 2,
                width,
                height,
                r: 4
              },
              style: {
                ...api.style(),
                fill: legendColors[3],
                opacity: 0.8
              },
              emphasis: {
                style: {
                  stroke: legendColors[3],
                  lineWidth: 2
                }
              },
              z2: 10
            }, width < 5
              ? {
                  type: 'polygon',
                  shape: {
                    points: [[start[0] + width / 2 - mWidth / 2, start[1] - height / 2 - 0.7 * mHeight], [start[0] + width / 2 + mWidth / 2, start[1] - height / 2 - 0.7 * mHeight], [start[0] + width / 2, start[1] - height / 2 + 0.3 * mHeight]]
                  },
                  style: {
                    ...api.style(),
                    fill: legendColors[3],
                    opacity: 0.8
                  },
                  emphasis: {
                    style: {
                      stroke: legendColors[3],
                      lineWidth: 2
                    }
                  },
                  z2: 12
                }
              : { type: 'polygon' }]
          }
        },
        encode: {
          x: [0, 1],
          y: 2
        },
        data: dataLeave
      }
    ]
  };

  artifact_chart.setOption(option);
}
